const safeAddress = m => {
    return !!m ? m.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]|[.#$[\] ]/g, "").replace(/ñ/g, "n") : '';
}
export default safeAddress